import { AdexiumBoostProvider } from './Providers/AdexiumBoostProvider';
import { tadsBoostProvider } from './Providers/TadsBoostProvider';
import { AdServiceManager } from './AdServiseManager';
import { barzaBoostProvider } from './Providers/BarzhaBoostProvider';
import { AdextraBoostProvider } from './Providers/AdextraBoostProvider';
import { AdsgramBoostProvider } from './Providers/AdsgramBoostProvider';
import { adsgramCPCBoostProvider } from './Providers/AdsgramCpcBoostProvider';
import { fLyerAndInnerBoostProvider } from './Providers/FLyerAndInnerBoostProvider';

export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}
export class AdService {
  static initialize() {
    AdServiceManager.registerProvider(fLyerAndInnerBoostProvider, 7);
    AdServiceManager.registerProvider(barzaBoostProvider, 6);
    // AdServiceManager.registerProvider(tadsBoostProvider, 5);
    AdServiceManager.registerProvider(adsgramCPCBoostProvider, 4);
    AdServiceManager.registerProvider(new AdextraBoostProvider(), 3);
    AdServiceManager.registerProvider(new AdexiumBoostProvider(), 2);
    AdServiceManager.registerProvider(new AdsgramBoostProvider(), 1);
  }

  static async getAllAvailableTasks(): Promise<BoostTask[]> {
    console.log('BoostMiningService: Getting all available tasks...');
    const allTasks: BoostTask[] = [];
    const providers = AdServiceManager.getProviders();
    const processedProviders = new Set<string>();

    for (const provider of providers) {
      const providerName = provider.getName();
      if (processedProviders.has(providerName)) {
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found: ${allTasks.length}`,
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoCpm(): Promise<BoostTask[]> {
    console.log('BoostMiningService: Getting all available tasks (no CPM)...');
    const allTasks: BoostTask[] = [];
    const providers = AdServiceManager.getProviders();
    const processedProviders = new Set<string>();

    const allowedProviders = ['Tads', 'Barza', 'AdsgramCPC', 'FLyerAndInner'];

    for (const provider of providers) {
      const providerName = provider.getName();
      console.log(providerName, 'providerNameSSSыsss');
      if (!allowedProviders.includes(providerName)) {
        console.log(
          `Пропускаем провайдер ${providerName} (не в списке разрешенных для no CPM)`,
        );
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no CPM): ${allTasks.length}`,
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoCpc(): Promise<BoostTask[]> {
    console.log('BoostMiningService: Getting all available tasks (no CPC)...');
    const allTasks: BoostTask[] = [];
    const providers = AdServiceManager.getProviders();
    const processedProviders = new Set<string>();

    const allowedProviders = ['adexium', 'adextra', 'adsgram_cpm'];

    for (const provider of providers) {
      const providerName = provider.getName();

      if (!allowedProviders.includes(providerName)) {
        console.log(
          `Пропускаем провайдер ${providerName} (не в списке разрешенных для no CPC)`,
        );
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no CPC): ${allTasks.length}`,
    );
    return allTasks;
  }

  static resetBoostState() {
    console.log('Resetting boost state (clearing provider errors)');
    AdServiceManager.getProviders().forEach((provider) => {
      if (typeof provider.resetError === 'function') {
        provider.resetError();
      }
    });
  }
}

// Инициализируем провайдеры при импорте сервиса
AdService.initialize();
